import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    'active-menu': 'general',
    error: [],
    message:[],
    code: "",
    holidays: {
        is_dirty: false,
    },
    venues: {
        is_dirty: false,
    },
    locations: {
        is_dirty: false,
    },
    events: {
        is_dirty: false,
    },
    config:{
        from:0,
        to:0,
        lastPage:1,
        rowCount:0,
        pagination:{
            page:0,
            pageSize:3,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_SELECTED_SETTING:
            return {
                ...state,
                selected: state.list.filter(item => item.setting_id === action.payload)[0],
            }
        case CONST.SET_ACTIVE_MENU:
            return {
                ...state,
                'active-menu': action.payload,
            }
        case CONST.FETCH_SETTINGS_SUCCESS:
            return {
                ...state,
                list:action.payload.data,
                error: [],
                message: ["Settings loaded successfully"]
            }
        case CONST.FETCH_SETTINGS_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }

        case CONST.UPDATE_SETTING_SUCCESS:
            const indexU = state.list.findIndex(item => item.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["Settings updated successfully"],
                code:action.payload.status,
            }
        case CONST.UPDATE_SETTING_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }

        case 'ADD_HOLIDAY_SUCCESS':
        case 'UPDATE_HOLIDAY_SUCCESS':
        case 'DELETE_HOLIDAY_SUCCESS':
            return {
                ...state,
                holidays: {
                    ...state.holidays,
                    is_dirty: true,
                },
            }

        case 'FETCH_HOLIDAYS_SUCCESS':
            return {
                ...state,
                holidays: {
                    ...state.holidays,
                    is_dirty: false,
                },
            }

        case 'ADD_VENUE_SUCCESS':
        case 'UPDATE_VENUE_SUCCESS':
        case 'DELETE_VENUE_SUCCESS':
            return {
                ...state,
                venues: {
                    ...state.venues,
                    is_dirty: true,
                },
            }

        case 'FETCH_VENUES_SUCCESS':
            return {
                ...state,
                venues: {
                    ...state.venues,
                    is_dirty: false,
                },
            }

        case 'ADD_LOCATION_SUCCESS':
        case 'UPDATE_LOCATION_SUCCESS':
        case 'DELETE_LOCATION_SUCCESS':
            return {
                ...state,
                locations: {
                    ...state.locations,
                    is_dirty: true,
                },
            }

        case 'FETCH_LOCATIONS_SUCCESS':
            return {
                ...state,
                locations: {
                    ...state.locations,
                    is_dirty: false,
                },
            }

        case 'ADD_EVENT_SUCCESS':
        case 'UPDATE_EVENT_SUCCESS':
        case 'DELETE_EVENT_SUCCESS':
            return {
                ...state,
                events: {
                    ...state.events,
                    is_dirty: true,
                },
            }

        case 'FETCH_EVENTS_SUCCESS':
            return {
                ...state,
                events: {
                    ...state.events,
                    is_dirty: false,
                },
            }

        default:
            return state;
    }
}

export default Reducer ;